import {useSyncExternalStore} from 'react';

// ponytail: fora do AuthContext de propósito. Como flag do context, cada
// abrir/fechar trocava a identidade do value e re-renderizava os ~66
// consumidores de useAuth() — inclusive todo StationItem de lista. Aqui só
// re-renderiza quem chama useShouldShowOTPModal().
let visible = false;
let dismissable = true;
const listeners = new Set<() => void>();

export function setShouldShowOTPModal(
  next: boolean,
  options?: {dismissable?: boolean},
) {
  const nextDismissable = next ? options?.dismissable ?? true : true;

  if (visible === next && dismissable === nextDismissable) {
    return;
  }
  visible = next;
  dismissable = nextDismissable;
  listeners.forEach(listener => listener());
}

export function useShouldShowOTPModal() {
  return useSyncExternalStore(
    listener => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
    () => visible,
  );
}

export function useOTPModalDismissable() {
  return useSyncExternalStore(
    listener => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
    () => dismissable,
  );
}
